// Genie mascot library — typed maps over the assets in public/genie-mascots/.
//
// Three libraries today:
//   - vertical: broad industry verticals (appliances, automotive, marine, ...)
//   - industry: more specific niches (coffee, hvac, plant-hire, ...)
//   - brand:    co-branded mascots for sales demos (apple, audi, tesla, ...)
//
// A fourth library (role) is generated separately by
// scripts/generate-genie-concepts-v3.js for the jobs-to-be-done catalogue
// (onboarding, compliance, audit, ...). Imported here once the run completes.

import { roleMascots, type RoleSlug } from "./genieMascotsRole";

export type VerticalSlug =
  | "appliances"
  | "automotive"
  | "equipment"
  | "industrial"
  | "manufacturing"
  | "marine"
  | "mining"
  | "office-equipment"
  | "trades"
  | "travel-hospitality";

export type IndustrySlug =
  | "agricultural"
  | "av-events"
  | "campervan"
  | "coffee"
  | "commercial-kitchen"
  | "holiday-park"
  | "hvac"
  | "plant-hire"
  | "power-tools";

export type BrandSlug =
  | "apple"
  | "apple-portrait"
  | "audi"
  | "bmw"
  | "bosch"
  | "caterpillar"
  | "john-deere"
  | "panasonic"
  | "samsung"
  | "siemens"
  | "tesla";

const mascot = (folder: string, slug: string) => `/genie-mascots/${folder}/${slug}.png`;

export const verticalMascots: Record<VerticalSlug, string> = {
  appliances: mascot("vertical", "appliances"),
  automotive: mascot("vertical", "automotive"),
  equipment: mascot("vertical", "equipment"),
  industrial: mascot("vertical", "industrial"),
  manufacturing: mascot("vertical", "manufacturing"),
  marine: mascot("vertical", "marine"),
  mining: mascot("vertical", "mining"),
  "office-equipment": mascot("vertical", "office-equipment"),
  trades: mascot("vertical", "trades"),
  "travel-hospitality": mascot("vertical", "travel-hospitality"),
};

export const industryMascots: Record<IndustrySlug, string> = {
  agricultural: mascot("industry", "agricultural"),
  "av-events": mascot("industry", "av-events"),
  campervan: mascot("industry", "campervan"),
  coffee: mascot("industry", "coffee"),
  "commercial-kitchen": mascot("industry", "commercial-kitchen"),
  "holiday-park": mascot("industry", "holiday-park"),
  hvac: mascot("industry", "hvac"),
  "plant-hire": mascot("industry", "plant-hire"),
  "power-tools": mascot("industry", "power-tools"),
};

export const brandMascots: Record<BrandSlug, string> = {
  apple: mascot("brand", "apple"),
  "apple-portrait": mascot("brand", "apple-portrait"),
  audi: mascot("brand", "audi"),
  bmw: mascot("brand", "bmw"),
  bosch: mascot("brand", "bosch"),
  caterpillar: mascot("brand", "caterpillar"),
  "john-deere": mascot("brand", "john-deere"),
  panasonic: mascot("brand", "panasonic"),
  samsung: mascot("brand", "samsung"),
  siemens: mascot("brand", "siemens"),
  tesla: mascot("brand", "tesla"),
};

export { roleMascots };
export type { RoleSlug };

export const allMascots = {
  vertical: verticalMascots,
  industry: industryMascots,
  brand: brandMascots,
  role: roleMascots,
};
